import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import { CompanyDeletion } from 'modules/core/store/models/Company'

interface Params {
  deletion: CompanyDeletion
}

const CompanyDeletionModal = ({ deletion }: Params) => {
  const [isCompanyDeletionModalOpen, setCompanyDeletionModalOpen] = useState(true)

  const {
    access: { locale },
  } = useCurrentSession()

  if (!isCompanyDeletionModalOpen) {
    return null
  }

  const endDate = moment(deletion.access.revoke_at.toString())
  const now = moment()
  const dayCount = endDate.diff(now, 'days')

  const localizedUrl = (localize: string) => {
    switch (localize) {
      case 'de':
        return 'https://factorialhr.de/sicherheit'
      case 'en-gb':
        return 'https://factorialhr.co.uk/security'
      case 'pt-br':
        return 'https://factorialhr.com.br/seguranca'
      case 'pt':
        return 'https://factorialhr.pt/seguranca'
      case 'it':
        return 'https://factorial.it/sicurezza'
      case 'fr':
        return 'https://factorial.fr/securite'
      case 'es':
        return 'https://factorial.es/informacion-segura'
      case 'es-mx':
        return 'https://factorial.mx/informacion-segura'
      default:
        return 'https://factorialhr.com/security'
    }
  }

  return (
    <Modal
      onClose={() => setCompanyDeletionModalOpen(false)}
      illustration="uninstall"
      title={i18n.t('company_deletion_modal.title', { days: dayCount })}
      description={i18n.t('company_deletion_modal.description', { days: dayCount })}
      footer={
        <>
          <Button
            type="secondary"
            iconName="external link"
            onClick={() => window.open(localizedUrl(locale || 'en-us'))}
          >
            {i18n.t('company_deletion_modal.more_information')}
          </Button>
          <Button type="primary" onClick={() => setCompanyDeletionModalOpen(false)}>
            {i18n.t('company_deletion_modal.button')}
          </Button>
        </>
      }
    />
  )
}

export default CompanyDeletionModal
